import React from 'react';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';

import Button from 'components/Button';


const ToggleShortlistButton = observer(({ unitId, ...props }) => {
    const { shortlistStore } = useDataStore();

    const isShortlisted = shortlistStore.shortlistedUnits.has(unitId);
    
    const handleToggle = () => {
        shortlistStore.toggleShortlist(unitId);
    };
    
    return (
        <Button 
            active={isShortlisted}
            onClick={handleToggle}
            title={isShortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
            {...props}
        >
            {isShortlisted ? '✓ Apartment Shortlisted' : '+ Shortlist apartment'}
        </Button>
    );
});


export default ToggleShortlistButton;
